




































































import { getContracts } from '@/api/api';
import { Component, Vue } from 'vue-property-decorator';
import ContractsDisplayer from '@/components/ContractsDisplayer.vue'
import { addTypeContract } from '@/api/api'
@Component({
    components: {
        ContractsDisplayer
    },
})
export default class Contracts extends Vue {
    contracts = null;
    contractsActive = [];
    contractTypeActive: any = null;

    popupNewType: boolean = false;
    newType: string = '';

    async created() {
        const el = this.$refs.loadingContracts as HTMLElement;
        // @ts-ignore
        this.$vs.loading({
            container: el,
        });
        const { data } = await getContracts();
        console.log(data)
        this.contracts = data;
        // @ts-ignore
        this.$vs.loading.close(el);

    }

    async addType() {
        const { data } = await addTypeContract(this.newType);
        //@ts-ignore
        this.$vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Succès',
            text: 'Type de contrat crée',
        });
        return window.location.reload()
    }

    getContractsActive() {
        return this.contractsActive
    }

    isActive(type: any) {
        return type === this.contractTypeActive
    }


    setContractsActive(data: any) {
        this.contractsActive = data.contracts
        this.contractTypeActive = data.type;
    }
}
